<template>
    <el-container style="height: 100%;">
        <page-header-annual-fee/>
        <el-header height="63px">
            <page-header></page-header>
        </el-header>
        <el-container class="layout-container">
            <el-aside width="auto" style="background: #e7e7e7" class="layout-aside">
                <nav-side></nav-side>
            </el-aside>
            <el-main class="layout-main">
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import NavSide from './modules/nav_side/nav.vue'
import PageHeader from './modules/header/header.vue'
import PageHeaderAnnualFee from './modules/header/header_annual_fee.vue'
import { openMessage } from '@/utils/system.tsx'
import { $fetch } from '@/api/index.ts'
import { useStore } from '@/store/index'
export default {
    components: {
        NavSide,
        PageHeader,
        PageHeaderAnnualFee
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-header {
    padding: 0;
    z-index: 100;
}

.layout-main {
    padding: 0 10px;
    // box-sizing: border-box;
}
</style>